/**
 * Add to cart standalone button helper
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

'use strict';

import forEach from '../../utils/forEach';
import store from '../../store';

export default class AddToCartButton {

    constructor() {

        forEach(document.querySelectorAll('*[role="add-to-cart"]'), (index, el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                store.dispatch('cart/addItem', { id: el.dataset.id, qty: 1 });
            });
        });

    }

}
